import { Injectable } from '@angular/core';
import { AutofillProfile } from '../autofill-profile';
import { AutofillRule } from '../autofill-rule';
import { AutofillOption } from '../autofill-option';
import { AutofillConfig } from '../autofill-config';

@Injectable({
  providedIn: 'root'
})
export class AutofillService {

  constructor() { }

  stringToObject(str: string): AutofillConfig{
    let strArray = this.separateString(str);
    let first = strArray[0];
    let second = strArray[1];
    let third = strArray[2];
    
    let rules = this.linesToAutofillRules(second);
    let profiles = this.linesToProfiles(first);
    let options = this.linesToAutofillOptions(third);

    return new AutofillConfig(profiles, rules, options);
  }

  linesToAutofillRules(str: string){
    let strWithoutLinebreak = str.replace(/\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/g, ",");
    const lines = strWithoutLinebreak.split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
    const result = [];
    for(let i = 0; i < lines.length; i += 7){
      result.push(new AutofillRule(lines[i], lines[i + 1], lines[i + 2], lines[i + 3], lines[i + 4], Number(lines[i + 5]), lines[i + 6]));
    }

    return result;
  }

  linesToAutofillOptions(str: string){
    let strWithoutLinebreak = str.replace(/\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/g, ",");
    const lines = strWithoutLinebreak.split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
    const result = [];
    for(let i = 0; i < lines.length; i += 7){
      result.push(new AutofillOption(lines[i], lines[i + 1], lines[i + 2]));
    }

    return result;
  }

  linesToProfiles(str: string){
    let strWithoutLinebreak = str.replace(/\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/g, ",");
    const lines = strWithoutLinebreak.split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/);
    const result = [];
    for(let i = 0; i < lines.length; i += 7){
      result.push(new AutofillProfile(lines[i], lines[i + 1], lines[i + 2], lines[i + 3]));
    }

    return result;
  }

  separateString(input: string){
    let profilesHeader = "### AUTOFILL PROFILES ###,,,,,,\nProfile ID,Name,Site,Hotkey,,,";
    let rulesHeader = "### AUTOFILL RULES ###,,,,,,\nRule ID,Type,Name,Value,Site,Mode,Profile";
    let optionsHeader = "### AUTOFILL OPTIONS ###,,,,,,";
    let firstPart = input.split(profilesHeader);
    let firstPartToSend = firstPart[1].split(rulesHeader);
    let secondPart = firstPart[1].split(rulesHeader);
    secondPart = secondPart[1].split(optionsHeader);

    let result = [];
    result.push(firstPartToSend[0].trim());
    result.push(secondPart[0].trim());
    result.push(secondPart[1].trim());

    return result;
  }

  objectToString(config: AutofillConfig): string{

    let profilesHeader = "### AUTOFILL PROFILES ###,,,,,,\nProfile ID,Name,Site,Hotkey,,,\n";
    let rulesHeader = "### AUTOFILL RULES ###,,,,,,\nRule ID,Type,Name,Value,Site,Mode,Profile\n";
    let optionsHeader = "### AUTOFILL OPTIONS ###,,,,,,\n";

    let profiles = config.profiles;
    let strs = [];
    strs.push(profilesHeader);
    for(let profil of profiles){
      strs.push(profil.profileId + "," + profil.name + "," + profil.site + "," + profil.hotkey + ",,,,\n");
    }
    let rules = config.rules;
    strs.push(rulesHeader);
    for(let rule of rules){
      strs.push(rule.ruleId + "," + rule.type + "," + rule.name + "," + rule.value + "," + rule.site + "," + rule.mode + "," + rule.profile + "\n");
    }

    let options = config.options;
    strs.push(optionsHeader);
    for(let option of options){
      strs.push(option.name + "," + option.mode + "," + option.link + ",,,,\n");
    }

    let result = "";
    for(let str of strs){
      result = result + str;
    }

    return result;
  }

  merge(config1: AutofillConfig, config2: AutofillConfig): AutofillConfig{

    let profilesToUpdate: AutofillProfile[] = [];
    let newProfilesToAdd: AutofillProfile[] = [];

    profileLoop1: for(let profile2 of config2.profiles){
      for(let profile1 of config1.profiles){
        if(profile2.profileId == profile1.profileId){
          if(profile2.hotkey == profile1.hotkey && profile2.name == profile1.name && profile2.site == profile1.site){
            continue profileLoop1;
          } else {
            profilesToUpdate.push(profile2);
          } 
        }
      }
    }
    let lastProfile1 = config1.profiles[config1.profiles.length - 1];
    let lastProfile2 = config2.profiles[config2.profiles.length - 1];
    let lastProfileId1 = lastProfile1.profileId;
    let lastProfileId2 = lastProfile2.profileId;
    let newProfileIdNumber = Math.max(Number(lastProfileId1.replace("c", "")), Number(lastProfileId2.replace("c", ""))) + 1;
    if(profilesToUpdate.length > 0){
      for(let profil of profilesToUpdate){
        for(let rule of config2.rules){
          if(rule.profile == profil.profileId){
            rule.profile = "c" + newProfileIdNumber;
          }
        }
        profil.profileId = "c" + newProfileIdNumber;
        newProfileIdNumber++;
      }
    }
    config1.profiles = config1.profiles.concat(profilesToUpdate);

    let newRules = [];
    ruleLoop1: for(let rule2 of config2.rules){
      for(let rule1 of config1.rules){
        if(rule2.ruleId == rule1.ruleId){
          if(rule2.name == rule1.name && rule2.type == rule1.type && rule2.value == rule1.value 
            && rule2.profile == rule1.profile && rule2.site == rule1.site){
            continue ruleLoop1;
          } else {
            newRules.push(rule2);
            continue ruleLoop1;
          }
        }
      }
      config1.rules.push(rule2);
    }
    let lastRule1 = config1.rules[config1.rules.length - 1];
    let lastRule2 = config2.rules[config2.rules.length - 1];
    let lastRuleId1 = lastRule1.ruleId;
    let lastRuleId2 = lastRule2.ruleId;
    let newIdNumber = Math.max(Number(lastRuleId1.replace("r", "")), Number(lastRuleId2.replace("r", ""))) + 1;

    if(newRules.length > 0){
      for(let rule of newRules){
        rule.ruleId = "r" + newIdNumber;
        newIdNumber++;
      }
    }
    config1.rules = config1.rules.concat(newRules);

    return config1;
  }

}
